export const userNav = {
    items: [
        { text: 'Users', to: '/admin/user/list' },
        { text: 'User Groups', to: '/admin/user/groups' },
        { text: 'Customers', to: '/admin/user/customer' },
    ],
    header: 'Users'
};

export const productNav = {
    items: [
        { text: 'Modifier Group', to: '/admin/products/groupOfModifiers' },
        { text: 'Modifiers', to: '/admin/products/modifiers' },
        { text: 'Categories', to: '/admin/products/categories' },
        { text: 'Ingredients', to: '/admin/products/ingredients' },
        { text: 'Products', to: '/admin/products/list' },
        { text: 'Courses', to: '/admin/products/courses' },
        { text: 'Discounts', to: '/admin/products/discount' },
    ],
    header: 'Products'
};

export const ComboNav = {
    items: [
        { text: 'Combos', to: '/admin/combos/list' },
        { text: 'Choices', to: '/admin/combos/choices' },
    ],
    header: 'Combos'
};

export const deviceNav = {
    items: [
        { text: 'Devices', to: '/admin/devices/list' },
    ],
    header: 'Devices'
};

export const printerNav = {
    items: [
        { text: 'Printers', to: '/admin/printing/list' },
    ],
    header: 'Printers'
};

export const orderNav = {
    items: [
        { text: 'Orders', to: '/admin/order/list' },
    ],
    header: 'Orders'
};

export const settingNav = {
    items: [
        { text: 'Manage Restaurants', to: '/admin/settings/restaurants' },
        // { text: 'Payments', to: '/admin/settings/payments' },
        { text: 'Company Settings', to: '/admin/settings/company' },
    ],
    header: 'Settings'
};

export const floorNav = {
    items: [
        { text: 'Floors', to: '/admin/floor/create' },
    ],
    header: 'Floors'
};

export const paymentNav = {
    items: [
        { text: 'Payment Types', to: '/admin/payment/type' },
    ],
    header: 'Payments'
};

export const dashboardNav = {
    items: [
        { text: 'Dashboard', to: '/admin/dashboard/view' },
    ],
    header: 'Dashboard'
};

export const reportNav = {
    items: [
        // { text: 'Dashboard', to: '/admin/report/dashboard' },
        { text: 'Receipts', to: '/admin/report/receipt' },
        { text: 'Labour Reports', to: '/admin/report/labour' },
        { text: 'Hour Reports', to: '/admin/report/hour' },
        { text: 'Day Reports', to: '/admin/report/day' },
        { text: 'Week Reports', to: '/admin/report/week' },
        { text: 'Month Reports', to: '/admin/report/month' },
        { text: 'Product Reports', to: '/admin/report/product' },
        { text: 'Category Reports', to: '/admin/report/category' },
        // { text: 'User Reports', to: '/admin/report/user' },
        { text: 'Table Reports', to: '/admin/report/table' },
    ],
    header: 'Reports'
};

export const auditNav = {
    items: [
        { text: 'Users Audit', to: '/admin/audit/list'}
    ],
    header: 'Users Audit'
}

export const permissionNav = {
    items: [
        { text: 'Permissions', to: '/admin/permissions'}
    ],
    header: 'Permissions'
}